import { memoize } from "lodash";
import getCoreUIStore from "../core/core-ui-store";
import { apiCallAssignClientToKhattabat } from "../../api/khattbat-api/api-call-assign-client-to-khattaba";
import getCorePopUpStore from "../core/core-popup-store";
import getDashBoardStore from "../dashboard-store";
import { computed } from "mobx";
import { isPositiveNumber } from "et3-type-guards";

class KhattabatAssignStore {
  checkifNewClientsAvailable = computed(() => {
    return isPositiveNumber(
      getDashBoardStore().totalUnassignedNewClients.get()
    );
  });

  succesfullClientAssignment = () => {
    getDashBoardStore().decrementUnassignedNewClients();
    getCorePopUpStore().showSuccessMessage("SUCCESS");
  };

  assignClientToKhattaba = async () => {
    getCorePopUpStore().closeConfirmationPopUps();
    if (!this.checkifNewClientsAvailable.get()) {
      getCorePopUpStore().showAlertMessage("NO_NEW_CLIENTS_AVAILABLE");
      return;
    }
    getCoreUIStore().setIsLoading("KHATTABAT_NEW_CLIENTS", true);
    const { code, status } = await apiCallAssignClientToKhattabat();
    if (status === "ERROR") {
      if (code === "NO_NEW_CLIENTS_AVAILABLE")
        getDashBoardStore().totalUnassignedNewClients.set(0);
      getCorePopUpStore().showAlertMessage(code);
    } else {
      this.succesfullClientAssignment();
    }
    getCoreUIStore().setIsLoading("KHATTABAT_NEW_CLIENTS", false);
  };
}

export const getKhattabatAssignStore = memoize(
  () => {
    return new KhattabatAssignStore();
  },
  () => 1
);

export default getKhattabatAssignStore;
